import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
export const getTemplatesUrl = () => `${getFullUrl('app')}/templates/${PortalIdParser.get()}`;
const TemplatesPopoverEmptyState = () => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
  image: "templates",
  title: "hubspot-prosemirror.templates.zeroState.header",
  description: "hubspot-prosemirror.templates.zeroState.description",
  buttonLabel: "hubspot-prosemirror.templates.zeroState.button",
  buttonLink: getTemplatesUrl()
});
export default TemplatesPopoverEmptyState;